import qs from "qs";
import axios from "../helpers/axios";

import {
  CreateJournalEntryBody,
  JournalEntryCursor,
  JournalEntryItem,
  JournalEntryResult,
  JournalEntrySearchQuery,
  JournalGlAccount,
  ReverseJournalEntryBody,
} from "../types/journalEntries";

type GetJournalEntriesQuery = {
  pageSize: number;
  searchQuery: JournalEntrySearchQuery;
  cursor?: JournalEntryCursor;
};

type JournalEntriesResponse = {
  items: JournalEntryItem[];
  glAccounts: JournalGlAccount[];
  nextCursor: JournalEntryCursor | null;
};

export const getJournalEntries = async ({
  pageSize,
  searchQuery,
  cursor,
}: GetJournalEntriesQuery): Promise<JournalEntryResult> => {
  const params = {
    start: searchQuery.start,
    end: searchQuery.end,
    glAccountCode: searchQuery.glAccountCode,
    entryType: searchQuery.entryType,
    sortBy: searchQuery.sortBy,
    sortDir: searchQuery.sortDir,
    limit: pageSize + 1,
    cursorSortValue: cursor?.sortValue,
    cursorId: cursor?.id,
  };

  const { data } = await axios.get<JournalEntriesResponse>(
    "/admin/ledger/journal-entries",
    {
      params,
      paramsSerializer: (p) => qs.stringify(p, { skipNulls: true }),
    }
  );

  // limit is pageSize + 1, so the extra row is only a hasMore probe.
  const fetched = Array.isArray(data?.items) ? data.items : [];
  const hasMore = fetched.length > pageSize;

  return {
    items: hasMore ? fetched.slice(0, pageSize) : fetched,
    glAccounts: Array.isArray(data?.glAccounts) ? data.glAccounts : [],
    pageSize,
    hasMore,
  };
};

export const createJournalEntry = async (body: CreateJournalEntryBody) => {
  const { data } = await axios.post<{ transactionId: string }>(
    "/admin/ledger/journal-entries",
    body
  );
  return data;
};

export const reverseJournalEntry = async (body: ReverseJournalEntryBody) => {
  const { data } = await axios.post<{ transactionId: string }>(
    "/admin/ledger/journal-entries/reversal",
    body
  );
  return data;
};
